// extracted by mini-css-extract-plugin
module.exports = {"flip":"Popup_flip__yoiEc","backgroundImage":"Popup_backgroundImage__TMwaf","background":"Popup_background__cBOyh","container":"Popup_container__OmPAY"};